const styles = () => ({
  lazyLoadImageContainer: {
    position: 'relative',
    marginLeft: 'auto',
    marginRight: 'auto',
    lineHeight: 0,
  },
});

export default styles;
